<template>
	<div class="MarketingPlan">
		<!-- <div class="bntGroup">
			<base-button @click="GoBack()" type="primary" class="no-border my-0" simple icon><i class="d-inline-block tim-icons icon-simple-remove"></i></base-button>
		</div> -->
		<!-- <div class="row mx-0 mb-3 align-items-center"></div> -->
			<div class="bntGroup">
				<base-button type="primary" class="groupfloor" simple @click="GoBack()" ><i class="tim-icons icon-double-left mr-2"></i>Назад</base-button>
			</div>
		
		<!-- <card></card> -->
			<MarketingPlanDetail :id="this.$route.params.plan_id" />
		
	</div>
</template>
<script>

import MarketingPlanDetail from "src/our_modules/MarketingModule/MarketingPlanDetail.vue";

export default {
	name: 'MarketingPlan-page',
	components: {
        MarketingPlanDetail,
	},
	props: {
		id: [String, Number],
		findId: { //это свойсво удалять не надо, оно хорошее и моет быть использовано в опуиях для формпринтера или фильтрпринтера
			type: String,
			default: '',
		},
		
	},
	data() {
		return {
			// masAllFormParams: this.currentFormConfig(),
			// currentApiFormMethod: this.currentApiFormMethodComp(),
		};
	},
	methods: {
		// currentFormConfig() {
		// 	let result_id = typeof this.$route.params.plan_id=='undefined'?null:this.$route.params.plan_id;
		// 	this.$GVO.ApiCall('marketing_plan.GET_FORM_MODEL',{flt:{'result_id':result_id}})
		// 		.then((objApi) => {
		// 			if(objApi.success){
		// 				this.masAllFormParams = objApi.config;
		// 			}
		// 		})
		// 		.catch(errorObjApi => console.log(errorObjApi));
		// 	return [];
		// },
		// currentApiFormMethodComp(){
		// 	let result_id = typeof this.$route.params.plan_id=='undefined'?'0':this.$route.params.plan_id;
        //     return {apiMethod:'marketing_plan.INSUPD',apiParam:{iData:[],flt:{'id':result_id}}};
        // },
		// SuccessGo(evt,dopParam){
	    //     this.$router.push({path: '/data/module/mo/marketing_plan'});
		// 	// this.$router.back();
		// },
		GoBack(){
			this.$router.back();
		},
	},		
	mounted() {

	}
};
</script>
<style scoped>
.MarketingPlan .bntGroup{
	position: absolute;
	z-index: 1;
	right: 40px;
}
</style>
